import styled, { css } from 'styled-components';

import { colors } from 'global/colors';

export const CardGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 10px;
  min-height: 300px;

  ${({ minHeight }) =>
    minHeight &&
    css`
      min-height: ${minHeight} !important;
    `}

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 736px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const CardWrapper = styled.div`
  position: relative;
  background: ${colors.white};
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
  max-width: 576px;
  cursor: pointer;
  border-radius: 5px;
  transition: all 0.25s ease-in-out;
  backface-visibility: hidden;
  transform: scale(1);
  overflow: hidden;

  :hover {
    transform: scale(1.02);
    box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.25);
    animation-fill-mode: forwards;
  }

  ${({ height }) =>
    height &&
    css`
      height: ${height};
    `}
`;

export const Image = styled.div`
  position: relative;
  width: 100%;
  height: 150px;
  background-image: url(${({ image }) => image || ''});
  background-size: cover;
  background-position: center center;
`;

export const CompletionContainer = styled.div`
  font-size: 11px;
  margin-top: 5px;
  text-align: right;
`;

export const CardInfoContainer = styled.div`
  padding: 10px;
  display: flex;
  flex-direction: column;
  height: calc(100% - 150px);
  cursor: ${({ pointerCursor }) => (pointerCursor ? 'pointer' : 'default')};
`;

export const CardInfoHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

export const CardName = styled.span`
  font-size: 14px;
  padding-bottom: 6px !important;
  color: ${colors.fsDarkBlue};
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  white-space: pre;
`;

export const CardCategory = styled.div`
  font-size: 12px;
  font-weight: 600;
  margin-top: 2px;
  color: ${colors.fsDarkBlue};
  white-space: pre;
`;

export const CardDetails = styled.div`
  font-size: 12px;
`;

export const CardDetailsAndTagContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const DetailsLabel = styled.label`
  font-weight: 600;
  margin-bottom: 0;
`;
